import React, { useState, useEffect } from 'react'
// import { locationContext } from '../../context/LocationContext.js';
import useFetch from '../../../../services/useFetch.js';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import Checkbox from '@mui/material/Checkbox';
import HoverOverTootlTip from '../../../Helpers/HoverOverToolTip';

/* 
    This is the module/component that will allow a user to add a menu item and then dynamically add ingredients
    that the menu item is composed of.
    Once the menu item is submitted, it will be used to determine the inventory lost when that item is purchased.
    Ingredient measurements do not need to be exact, but this tool will assume that each time the menu item is puchased by a customer,
        the ingredients used are to a very similar unit of measure as every other time the item has been purchased.
*/
export default function AddItemIngredients({ updateIngredients, itemCategory }) {

    /*Fetches the data ingredients to display in the dropdown */

    const [menuItemList, setMenuItemList] = useState([])
    const { data, error, load } = useFetch('api/ingredients', false)

    const [selectedData, setSelectedData] = useState(false)

    useEffect(() => {
        if (data) {
            data.map(ingr => {
                setMenuItemList(prevIng => [...prevIng, ingr.ingredient])
            })
        }
    }, [data])

    const [ingredients, setIngredients] = useState([
        {
            name: "",
            type: "regular",
            id: 0,
            toGoOnly: false,
            modOverride: false,
            units: [{ amount: "", measurement: "" }]
        }
    ]);

    const handleNameChange = (index, val, reason) => {

        if (reason !== 'clear') {
            const nmIndx = data.findIndex(item => item.ingredient === val)

            const newId = [...ingredients]
            const newIngredient = [...ingredients]
            newIngredient[index]['name'] = data[nmIndx].ingredient
            newId[index]['id'] = data[nmIndx].ingredientId

            updateIngredients(newIngredient)
            handleIdChange(newId)
            // setSelectedData(newIngredient)
            setSelectedData(true)
            handleMeasureChange(newId, index)
            setIngredients(newIngredient)
        }

    }

    const handleIdChange = (ingredientId) => {
        updateIngredients(ingredientId)
    }

    const handleAmountChange = (index, { target }) => {
        const newIngredient = [...ingredients]
        newIngredient[index]['units'][0].amount = parseFloat(target.value)

        updateIngredients(newIngredient)
    }

    /* ---------------------------------------------------------------------------------------------------------------------
    Will grab the measurement of the ingredient based on the ingredient chosen by the user 
    ---------------------------------------------------------------------------------------------------------------------*/
    const handleMeasureChange = (value, index) => {

        const newIngredient = [...ingredients]
        let fin = data.find(ele => ele.ingredientId === value[index].id)
        newIngredient[index]['units'][0].measurement = fin.recipeUoM
    }

    const handleCheck = (e, val, index, checkType) => {
        const newIngredient = [...ingredients]
        if (checkType === 'togo') {
            newIngredient[index]["toGoOnly"] = !newIngredient[index]["toGoOnly"]
        } else {
            newIngredient[index]["modOverride"] = !newIngredient[index]["modOverride"]
        }
        updateIngredients(newIngredient)
    }

    /* ---------------------------------------------------------------------------------------------------------------------
        This will delete the most recently added item to the Menu Item
    ---------------------------------------------------------------------------------------------------------------------*/
    const deleteRow = (index) => {
        const ingredientList = [...ingredients]
        const last = ingredients.length - 1

        if (index !== 0) {
            const indFrom = ingredientList.splice(0, index)
            const indTo = ingredientList.splice(index, last)
            const newList = indFrom.concat(indTo)

            setIngredients(newList)
            updateIngredients(newList)
        } else {
            setIngredients(ingredientList.splice(1, last))
            updateIngredients(ingredientList.splice(1, last))
        }

    }

    /* ---------------------------------------------------------------------------------------------------------------------
       This will add a new clothing + category dropdown on click of an add button
    ---------------------------------------------------------------------------------------------------------------------*/
    function onAdd() {
        setIngredients([...ingredients, { name: "", type: "regular", units: [{ amount: "", measurement: "" }] }])
    }
    if (load) {
        return (<div className="container"><CircularProgress /></div>)
    }

    return (
        <>
            { /* ----------------------------------------------------------------------------------------------------------------
            Maps through the ingredient state value (default is single empy arr val) and it adds a row each time the user
            selects the + button
            ----------------------------------------------------------------------------------------------------------------*/}
            {ingredients.map((elem, ind) =>


                <div className='row' style={{ margin: "0 25px 5px 25px", alignItems: 'center' }} key={ind}>

                    {/* 
                    This is the actual ingredient name
                     */}
                    <div className='col-3'>
                        <Autocomplete options={menuItemList} size='small'
                            onChange={(e, val, reason) => handleNameChange(ind, val, reason)}
                            // getOptionLabel={(option) => option.ingredient}
                            value={ingredients[ind].name || ""}
                            renderInput={(params) => <TextField {...params} placeholder='Select an ingredient'
                                name='Ingredient' /*value={elem}*/
                            />}
                        />
                    </div>

                    {/* 
                    This is the Units for that specific ingredient in the menu item 
                    */}
                    {itemCategory !== "Modifier" &&
                        <div className='col-2'>
                            <TextField
                                placeholder='Add Ingredient Units...'
                                style={{ width: "100%" }}
                                type="number" onChange={(e) => handleAmountChange(ind, e)}
                                value={elem.units[0].units} size='small'
                            />
                        </div>
                    }


                    {/* 
                    This is the meaurement for that specific ingredient in the menu item -- this is auto added based on the ingredient 
                    */}
                    {selectedData ? (
                        <div className='col-2'>
                            <TextField style={{ width: "100%" }}

                                type="text"
                                value={elem.units[0].measurement} disabled size='small'
                            />
                        </div>) :
                        <div className='col-2'>
                            <TextField style={{ width: "100%" }} value={'Awaiting item choice...'}
                                type="text" disabled size='small'
                            />
                        </div>
                    }
                    <div className="col-4" style={{ display: "flex", alignContent: "center" }}>
                        <div className='col-4' id='add-ingredient-togo'>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <Checkbox
                                    checked={ingredients[ind]["toGoOnly"]}
                                    onChange={(e, val) => handleCheck(e, val, ind, 'togo')} /> <label>To-Go only</label>
                            </div>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <HoverOverTootlTip message={"Gets replaced by modifier when ordered"} placement={"top"}>
                                    <Checkbox
                                        checked={ingredients[ind]["modOverride"]}
                                        onChange={(e, val) => handleCheck(e, val, ind, 'override')} /> <label>Mod. Override</label>
                                </HoverOverTootlTip>
                            </div>
                        </div>

                        <div className='col-6' style={{ alignSelf: 'center' }}>
                            <AddCircleOutlineIcon onClick={onAdd} fontSize='medium' sx={{ marginRight: '10px', cursor: 'pointer' }} />
                            <DeleteIcon onClick={() => deleteRow(ind)} sx={{ cursor: 'pointer' }} fontSize='medium' />
                        </div>
                    </div>

                </div>
            )}
            {ingredients.length === 0 &&
                <div className='row' style={{ marginLeft: "20px" }}>
                    <div className='col-12' style={{ alignSelf: 'center', marginBottom: '20px' }}>
                        <button className='recipe-bttn' onClick={onAdd} style={{ display: 'flex', justifyContent: 'center', fontSize: '16px' }}>
                            <AddCircleOutlineIcon onClick={onAdd} fontSize='medium' sx={{ marginRight: '10px', cursor: 'pointer' }} />
                            Add Ingredients
                        </button>

                        {/* <DeleteIcon onClick={() => deleteRow(null)} sx={{ cursor: 'pointer' }} fontSize='medium' /> */}
                    </div>
                </div>
            }


        </>
    )
}